/**
 * CONTENT SERVICE
 * 
 * Gestión de contenidos de la biblioteca y Journey
 */

import { BaseService } from '../base.service';
import { db } from '@/core/config/firebase';

import type { Content, ContentUpload } from '../../types/models/content/content.model';

export class ContentService extends BaseService<Content> {
  constructor() {
    super('content', db);
  }

  /**
   * Obtener contenidos por AMAR
   */
  async getByAmar(amarId: string): Promise<Content[]> {
    return this.query([['amarId', '==', amarId], ['active', '==', true]]);
  }

  /**
   * Obtener contenidos destacados
   */
  async getFeatured(): Promise<Content[]> {
    return this.query([['featured', '==', true], ['active', '==', true]]);
  }

  /**
   * Procesar upload con IA
   */
  async processUpload(uploadId: string): Promise<Content> {
    this.logger.info('Processing content upload', { uploadId });
    
    // Aquí se llamaría a una Cloud Function que:
    // 1. Lee el documento de Storage
    // 2. Lo procesa con Gemini
    // 3. Genera el contenido
    // 4. Crea el documento en content/
    // 5. Actualiza el upload con el contentId generado
    
    throw new Error('Not implemented - requires Cloud Function');
  }

  /**
   * Incrementar views
   */
  async incrementViews(contentId: string): Promise<void> {
    const content = await this.getById(contentId);
    if (!content) return;
    
    await this.update(contentId, {
      'stats.views': (content.stats?.views || 0) + 1
    } as any);
  }

  /**
   * Registrar completado
   */
  async recordCompletion(contentId: string, rating?: number): Promise<void> {
    const content = await this.getById(contentId);
    if (!content) return;
    
    const updates: any = {
      'stats.completions': (content.stats?.completions || 0) + 1
    };
    
    if (rating !== undefined) {
      const currentAvg = content.stats?.avgRating || 0;
      const completions = content.stats?.completions || 0;
      const newAvg = completions > 0 
        ? ((currentAvg * completions) + rating) / (completions + 1)
        : rating;
      
      updates['stats.avgRating'] = newAvg;
    }
    
    await this.update(contentId, updates);
  }
}

export const contentService = new ContentService();
